import { numberToHex } from '../../utils/encoding/toHex.js';
export async function switchChain(client, { id }) {
    await client.request({
        method: 'wallet_switchEthereumChain',
        params: [
            {
                chainId: numberToHex(id),
            },
        ],
    });
}
//# sourceMappingURL=switchChain.js.map